/*
 * Unofficial Reverso API.
 * Translate, get context examples or synonyms of words - this and much more
 * you can do with your text queries via this API wrapper.
 *
 * Source: reverso.net
 * Author: github.com/s0ftik3
 */

module.exports = require('./src/reverso')
